<template>
  <div class="d-flex oauth-btns justify-space-between">
    <div
      v-for="(provider, index) in providers"
      :key="provider.name"
      :class="[
        'btn-wrap flex-1 d-flex align-center justify-center has-hover-effect border-default',
        {
          'ml-4': index > 0,
        },
      ]"
      :disabled="provider.disabled"
      v-ripple
      @click="login(provider.name)"
    >
      <v-img
        :src="provider.icon"
        contain
        :height="provider.height"
        :width="provider.width"
      ></v-img>
    </div>
    <c-loading-dialog v-if="oauthLoggingIn" :title="processingText" />
  </div>
</template>
<script>
import Config from "@/common/config";
import { loginWithGoogle } from "@/common/lib/googleOauth";
import { loginWithFacebook } from "@/common/lib/facebookOauth";
import { loginWithTwitter } from "@/common/lib/twitterOauth";
export default {
  props: {
    processingText: {
      type: String,
      default: "Processing",
    },
    onSuccess: {
      type: Function,
      default() {
        return () => {};
      },
    },
  },
  data: () => ({
    oauthLoggingIn: false,
    providers: [
      {
        name: "google",
        icon: require("@/assets/icons/oauth-google.svg"),
        bgColor: "transparent",
        height: "18px",
        width: "18px",
      },
      {
        name: "twitter",
        icon: require("@/assets/icons/oauth-twitter.svg"),
        bgColor: "transparent",
        height: "20px",
        width: "24px",
      },
      {
        name: "facebook",
        icon: require("@/assets/icons/oauth-facebook.svg"),
        bgColor: "transparent",
        height: "20px",
        width: "12px",
      },
    ],
  }),
  methods: {
    async login(provider) {
      this.oauthLoggingIn = true;
      let payload = null;
      try {
        switch (provider) {
          case "google": {
            const loginDetails = await loginWithGoogle({
              clientId: Config.googleClientId,
              apiKey: Config.googleApiKey,
            });
            payload = { token: loginDetails.idToken };
            break;
          }
          case "facebook": {
            const loginDetails = await loginWithFacebook({
              appId: Config.facebookAppId,
              state: { pathname: window.location.pathname },
            });
            payload = { token: loginDetails.token };
            break;
          }
          case "twitter": {
            const { token } = await this.$store.dispatch("auth/requestToken", {
              callbackUrl: `${window.location.origin}/auth/oauth-redirect/twitter`,
            });
            const loginDetails = await loginWithTwitter({
              token,
            });
            payload = {
              token: loginDetails.token,
              oauth_verifier: loginDetails.verifier,
            };
            break;
          }
          default:
            break;
        }
        if (payload) {
          await this.$store.dispatch("auth/oauthLogin", {
            provider,
            payload,
          });
          this.$store.dispatch("closeAuthModal");
          this.$store.dispatch("addAlert", {
            type: "success",
            title: "auth.login.success.title",
            message: "auth.login.success.message",
          });
        }
      } catch (error) {
        console.error(error);
        this.$store.dispatch("addAlert", {
          type: "error",
          title: "Error",
          message: error.message,
        });
      }
      this.oauthLoggingIn = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.oauth-btns {
  .btn-wrap {
    height: 44px;
    border-radius: 50px;
  }
}
</style>
